import { Link } from 'react-router-dom';

export const RegisterIntro = () => {
  return (
    <div className="left">
        <h1>
            Nexia Social.
        </h1>

        <p>
            Ready to build something great? Create your Nexia Social profile today to network with fellow developers, showcase your projects, and join the conversation.
        </p>

        <span>
            Do you have an account?
        </span>

        <Link to="/login"> 
            <button>
                Login
            </button>
        </Link>
    </div>
  );
};